import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import BugCrowdCredentialsForm from './BugCrowdCredentialsForm'
import BugCrowdConfigListing from './BugCrowdConfigListing'

export default function BugCrowdPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={BugCrowdCredentialsForm}
            PullConfigListingView={BugCrowdConfigListing}
        />
    )
}